import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import XIcon from '@mui/icons-material/X';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import App from "../../template/images/App.svg";
import Google from "../../template/images/Google.svg";
import "./EventsLanding.css";

const DspFooter = () => {
  return (
    <div>
      {/* Custom Footer */}
      <footer className="events-footer">
        <div className="footer-wave"></div>
        <div className="container-lg">
          <div className="footer-content">
            {/* Contact Section */}
            <div className="footer-top">
              <div className="footer-contact-section">
                <div className="footer-title">Contact us</div>
                <div className="contact-items mt-3">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <EmailOutlinedIcon className="icon" />
                    </div>
                    <div className="contact-details">
                      <p className="contact-label">For any queries</p>
                      <p className="contact-value">Lorem@Ipsum.com</p>
                    </div>
                  </div>

                  <div className="contact-divider"></div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <CallOutlinedIcon className="icon" />
                    </div>
                    <div className="contact-details">
                      <p className="contact-label">
                        India : xxxxxxx4499 / xxxxxxx4499
                      </p>
                      <p className="contact-value">
                        International : xxxxxxx0066
                      </p>
                    </div>
                  </div>

                  <div className="contact-divider"></div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <WhatsAppIcon className="icon" />
                    </div>
                    <div className="contact-details">
                      <p className="contact-label">xxxxxx0000</p>
                      <p className="contact-value">
                        Say 'Hi' to us on Whatsapp
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="footer-right-section">
                <div className="download-app">
                  <div className="download-title">Download our app</div>
                  <div className="app-buttons">
                    <button
                      className="play-store-btn"
                      // onClick={() =>
                      //   window.open(
                      //     "https://play.google.com/store/apps/details?id=com.dsp.invest&hl=en&gl=US",
                      //     "_blank",
                      //     "noopener,noreferrer",
                      //   )
                      // }
                    >
                      <img src={Google} alt="Google Play" />
                    </button>
                    <button
                      className="app-store-btn"
                      // onClick={() =>
                      //   window.open(
                      //     "https://apps.apple.com/in/app/dsp-mutual-fund/id1475616503",
                      //     "_blank",
                      //     "noopener,noreferrer",
                      //   )
                      // }
                    >
                      <img src={App} alt="App Store" />
                    </button>
                  </div>
                </div>

                <div className="social-media">
                  <div className="social-title">Follow us</div>
                  <div className="social-icons">
                    <button
                      className="social-icon twitter"
                      aria-label="Twitter"
                      // onClick={() =>
                      //   window.open(
                      //     "https://x.com/dspmf",
                      //     "_blank",
                      //     "noopener,noreferrer",
                      //   )
                      // }
                    >
                      <XIcon />
                    </button>
                    <button
                      className="social-icon instagram"
                      aria-label="Instagram"
                      // onClick={() =>
                      //   window.open(
                      //     "https://www.instagram.com/dspmutualfund/?hl=en",
                      //     "_blank",
                      //     "noopener,noreferrer",
                      //   )
                      // }
                    >
                      <InstagramIcon />
                    </button>
                    <button
                      className="social-icon youtube"
                      aria-label="YouTube"
                      // onClick={() =>
                      //   window.open(
                      //     "https://www.youtube.com/channel/UC8D0OhZKnAbbFhFP6362tTw",
                      //     "_blank",
                      //     "noopener,noreferrer",
                      //   )
                      // }
                    >
                      <YouTubeIcon />
                    </button>
                    {/* <button
                      className="social-icon facebook"
                      aria-label="Facebook"
                      onClick={() =>
                        window.open(
                          "https://www.facebook.com/dspmutualfund/",
                          "_blank",
                          "noopener,noreferrer",
                        )
                      }
                    >
                      <FacebookIcon />
                    </button> */}
                    <button
                      className="social-icon linkedin"
                      aria-label="LinkedIn"
                      // onClick={() =>
                      //   window.open(
                      //     "https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGxDKuKWZPWuAAAAZ0gJdbg61PxjvatlOKYySp_a7kmDSYVc_3g9mG_PE_q6pa7M5PTZJg01-IadjmSkXjPmroPbmvqndS5DzP6zYgUyGuq8XziswSX8xcXu4CQLSIveS6-fbM=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fdspmf%2F",
                      //     "_blank",
                      //     "noopener,noreferrer",
                      //   )
                      // }
                    >
                      <LinkedInIcon />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-divider"></div>

            <div className="footer-bottom text-left">
              <p className="disclaimer">
               Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              </p>
              <button
                className="privacy-link"
                // onClick={() =>
                //   window.open(
                //     "https://www.dspim.com/privacy-policy",
                //     "_blank",
                //     "noopener,noreferrer",
                //   )
                // }
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DspFooter;
